import React, { Component } from 'react';
import ReactDOM from 'react-dom';

function withRippleEffect(WrappedComponent) {
	class HOC extends Component {
		constructor(props) {
			super(props);

			this.playRippleEffect = this.playRippleEffect.bind(this);
		}

		componentDidMount() {
			if (!this.rippleContainer) {
				throw new Error(
					'Container element need ref={props.rippleContainerRef} to ripple works'
				);
			}

			// Create and add ripple element
			const span = document.createElement('span');
			span.className = 'ripple';
			this.rippleContainer.appendChild(span);

			// Update wrapped component style
			this.rippleContainer.style.position = 'relative';
			this.rippleContainer.style.overflow = 'hidden';

			this.rippleContainer.addEventListener(
				'mousedown',
				this.playRippleEffect
			);

			// Keep a reference to use it when calling playRippleEffect()
			this.ripple = span;
		}

		componentWillUnmount() {
			this.rippleContainer.removeEventListener(
				'mousedown',
				this.playRippleEffect
			);
		}

		render() {
			return (
				<WrappedComponent
					{...this.props}
					rippleContainerRef={el => (this.rippleContainer = el)}
				/>
			);
		}

		playRippleEffect(event) {
			this.ripple.classList.remove('ripple--animate');

			const max = Math.max(
				this.rippleContainer.offsetWidth,
				this.rippleContainer.offsetHeight
			);
			const rect = this.rippleContainer.getBoundingClientRect();
			const x = Math.round(event.pageX - rect.left - max / 2);
			const y = Math.round(event.pageY - rect.top - max / 2);

			this.ripple.style.height = `${max}px`;
			this.ripple.style.width = `${max}px`;
			this.ripple.style.top = `${y}px`;
			this.ripple.style.left = `${x}px`;

			this.ripple.classList.add('ripple--animate');
		}
	}

	return HOC;
}

export default withRippleEffect;



// WEBPACK FOOTER //
// ./src/js/Ui/withRippleEffect.js